import { Button } from "@astryxdesign/core";
import { useEffect, useState } from "react";
import { Footer } from "@/components/Footer";
import { Nav } from "@/components/Nav";
import { PilotDialog } from "@/components/PilotDialog";
import { INTEGRATIONS } from "@/integrations";
import { openPilot } from "@/lib/pilot";

const PAGE_TITLE = "HireOS Integrations";

/**
 * What HireOS works with, as VXT lists its own: a title and a search on the
 * lime, then a card each, the mark on a tile, the name, and what kind of tool
 * it is. The rental systems we don't connect to yet say so on their card, and
 * the page ends by asking after whatever isn't listed.
 */
export default function IntegrationsPage() {
  const [q, setQ] = useState("");

  useEffect(() => {
    document.title = PAGE_TITLE;
  }, []);

  const find = q.trim().toLowerCase();
  const shown = INTEGRATIONS.filter(
    (i) => !find || i.name.toLowerCase().includes(find) || i.kind.toLowerCase().includes(find),
  );

  return (
    <>
      <Nav />

      <main className="lp">
        <section className="ig-head">
          <div className="col">
            <h1>Integrations</h1>
            <p>HireOS works inside the rental system, calendar and accounts your team already runs on.</p>
            <input
              type="search"
              placeholder="Search integrations"
              aria-label="Search integrations"
              value={q}
              onChange={(e) => setQ(e.target.value)}
            />
          </div>
        </section>

        <section className="col ig-list">
          {shown.length ? (
            <ul>
              {shown.map((i) => (
                <li key={i.name}>
                  <span className={`ig-tile${i.fill ? " fill" : ""}`}>
                    <img src={i.mark} alt="" />
                  </span>
                  <span>
                    <b>{i.name}</b>
                    <small>
                      {i.kind}
                      {i.ask && <em>On request</em>}
                    </small>
                  </span>
                </li>
              ))}
            </ul>
          ) : (
            <p className="ig-none">Nothing by that name yet. Ask us about it below.</p>
          )}

          <div className="ig-ask">
            <h2>Run something else?</h2>
            <p>Tell us what your team uses and we'll look at connecting it.</p>
            <div className="btns c">
              <Button label="Try for free" variant="ghost" onClick={openPilot} />
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <PilotDialog />
    </>
  );
}
